
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type verifyFitmentRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function verifyFitmentRT(): TemplateResult<verifyFitmentRTRootProps> {
    function repeatSplittedValue1(verifyFitmentInfo, value, valueIndex, splittedValue, splittedValueIndex) {
        return [_createElement('li', { 'key': '33161' }, splittedValue)];
    }
    function repeatValue2(verifyFitmentInfo, value, valueIndex) {
        return [_map(value.split('\n'), repeatSplittedValue1.bind(this, verifyFitmentInfo, value, valueIndex))];
    }
    function repeatSplittedValue3(verifyFitmentInfo, key, keyIndex, value, valueIndex, splittedValue, splittedValueIndex) {
        return [_createElement('li', { 'key': '39601' }, splittedValue)];
    }
    function repeatValue4(verifyFitmentInfo, key, keyIndex, value, valueIndex) {
        return [_map(value.split('\n'), repeatSplittedValue3.bind(this, verifyFitmentInfo, key, keyIndex, value, valueIndex))];
    }
    function repeatKey5(verifyFitmentInfo, key, keyIndex) {
        return [_createElement('div', {
                'className': 'cm_verify-fitment_vehicle-info',
                'key': '35371'
            }, _createElement('div', { 'className': 'cm_verify-fitment_vehicle-info__key' }, key, ':'), _createElement.apply(this, [
                'ul',
                { 'className': 'cm_verify-fitment_vehicle-info__values' },
                _map(verifyFitmentInfo[key], repeatValue4.bind(this, verifyFitmentInfo, key, keyIndex))
            ]))];
    }
    function scopeVerifyFitmentInfo6() {
        var verifyFitmentInfo = this.productData?.verify_fitment_info;
        return [verifyFitmentInfo && Object.keys(verifyFitmentInfo).length > 0 ? _createElement.apply(this, [
                'div',
                {
                    'className': 'cm_verify-fitment_vehicle-info__container',
                    'key': '27691'
                },
                _createElement('div', { 'className': 'cm_verify-fitment_vehicle-info__title' }, 'Vehicle Specific Notes'),
                verifyFitmentInfo['Notes'] ? _createElement.apply(this, [
                    'ul',
                    {
                        'className': 'cm_verify-fitment_vehicle-notes',
                        'key': '3117'
                    },
                    _map(verifyFitmentInfo['Notes'], repeatValue2.bind(this, verifyFitmentInfo))
                ]) : null,
                _map(Object.keys(verifyFitmentInfo).filter(v => v !== 'Notes'), repeatKey5.bind(this, verifyFitmentInfo))
            ]) : null];
    }
    function repeatSelects7(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n              ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n            ');
                }
                function repeatEntry2(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3(isQualifierField) {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n            ', _translate(`select_title`), ' ', this.title, '\n          ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '13431'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '13434'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                function scopeShowSelectedValues4(isQualifierField) {
                    var showSelectedValues = this.selectedEntries.length;
                    return _createElement('option', {
                        'key': '_current',
                        'value': '_current'
                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                        _translate(`select_title`),
                        ' ',
                        this.title
                    ] : null);
                }
                function repeatEntry5(isQualifierField, entry, index) {
                    return _createElement('div', {
                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                        'key': entry.value,
                        'onClick': () => this.onChange(entry.term)
                    }, this.showCheckboxes ? _createElement('input', {
                        'type': 'checkbox',
                        'readOnly': true,
                        'checked': entry.selected,
                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                        'key': '3617'
                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                        'className': 'cm_dropdown_hitCount',
                        'key': '3823'
                    }, entry.hitCount) : null);
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopeDescription7(isQualifierField) {
                    var description = _translate(`facet_details_${ this.field }`);
                    return [description ? _createElement('div', {
                            'className': 'cm_select-qualifier-details',
                            'key': '43591'
                        }, _createElement('button', { 'className': 'cm_select-qualifier-details_button' }, [_createElement('svg', {
                                'width': '24',
                                'height': '24',
                                'viewBox': '0 0 24 24',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '45860'
                            }, _createElement('g', { 'opacity': '0.6' }, _createElement('circle', {
                                'cx': '12',
                                'cy': '12',
                                'r': '11.5',
                                'stroke': 'black'
                            }), _createElement('path', {
                                'd': 'M12.768 14.72H11.28C11.28 13.8453 11.6267 13.0613 12.32 12.368C12.384 12.304 12.5867 12.112 12.928 11.792C13.28 11.4613 13.5093 11.232 13.616 11.104C13.7333 10.9653 13.8613 10.7573 14 10.48C14.1493 10.2027 14.224 9.936 14.224 9.68C14.224 9.15733 14.0427 8.752 13.68 8.464C13.3173 8.176 12.8373 8.032 12.24 8.032C11.0667 8.032 10.3147 8.54933 9.984 9.584L8.72 8.88C8.976 8.15467 9.41867 7.59467 10.048 7.2C10.688 6.79467 11.424 6.592 12.256 6.592C13.1947 6.592 14.0053 6.85867 14.688 7.392C15.3707 7.91467 15.712 8.656 15.712 9.616C15.712 10.448 15.3653 11.2107 14.672 11.904C14.6187 11.9573 14.4533 12.1173 14.176 12.384C13.8987 12.64 13.712 12.8267 13.616 12.944C13.52 13.0507 13.3867 13.216 13.216 13.44C13.0453 13.664 12.928 13.8773 12.864 14.08C12.8 14.2827 12.768 14.496 12.768 14.72ZM12.016 18.176C11.728 18.176 11.4827 18.0747 11.28 17.872C11.0773 17.6693 10.976 17.424 10.976 17.136C10.976 16.848 11.0773 16.6027 11.28 16.4C11.4827 16.1973 11.728 16.096 12.016 16.096C12.3147 16.096 12.56 16.1973 12.752 16.4C12.9547 16.6027 13.056 16.848 13.056 17.136C13.056 17.424 12.9547 17.6693 12.752 17.872C12.56 18.0747 12.3147 18.176 12.016 18.176Z',
                                'fill': 'black'
                            })))]), _createElement('div', { 'className': 'cm_select-qualifier-details_content' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-details_content-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_select-qualifier-details_content-text' }, description))) : null];
                }
                function repeatEntry8(isQualifierField, entry, entryIndex) {
                    return _createElement('div', {
                        'key': entry.value,
                        'className': 'cm_select-qualifier-value' + (entry.selected ? ' cm_select-qualifier-value_selected' : ''),
                        'onClick': () => this.onChange(entry.term)
                    }, '\n          ', entry.value, '\n        ');
                }
                function scopeIsQualifierField9() {
                    var isQualifierField = this.field?.startsWith('Qualifier_');
                    return _createElement('div', { 'className': this.extraClassName + (isQualifierField ? ' cm_select-qualifier-container' : '') }, !isQualifierField ? [
                        !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '1951'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_form-select form-select form-select--small',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, [isQualifierField]) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, [isQualifierField]) : null)) : null,
                        this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null,
                        !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '1955'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n        ', _translate(`select_title`), ' ', this.title, '\n      ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this, isQualifierField)) : null
                        ]) : null
                    ] : null, isQualifierField ? [
                        _createElement('div', {
                            'className': 'cm_select-qualifier-additional_details',
                            'key': '39481'
                        }, _translate(`ymm_bar_additional_details`)),
                        _createElement('div', {
                            'className': 'cm_select-qualifier',
                            'key': '39483'
                        }, _createElement('div', { 'className': 'cm_select-qualifier-header' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), scopeDescription7.apply(this, [isQualifierField])), _createElement.apply(this, [
                            'div',
                            { 'className': 'cm_select-qualifier-value_repeater' },
                            _map(this.entries, repeatEntry8.bind(this, isQualifierField))
                        ]))
                    ] : null);
                }
                return scopeIsQualifierField9.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__verify-fitment cm_verify-fitment' }, this.template === 'active' ? _createElement('div', {
        'className': 'cmTemplate_active',
        'key': '86'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_active' }, _createElement('div', { 'className': 'cm_vehicle-widget_active__content' }, _createElement('div', { 'className': 'cm_vehicle-widget_active__title' }, 'What are you driving?'), _createElement('div', { 'className': 'cm_vehicle-widget_active__text' }, 'Add your vehicle to get started')), _createElement('button', {
        'className': 'cm_vehicle-widget_active__button',
        'onClick': this.openDialog,
        'type': 'button',
        'tabIndex': '0'
    }, _createElement('span', {}, '\u2192')))) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__' + this.fits + ' cmTemplate_locked',
        'key': '625'
    }, _createElement('div', { 'className': 'cm_verify-fitment_fitment__container' }, _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_vehicle-widget_locked' }, _createElement('div', { 'className': 'cm_vehicle-widget_locked__main' }, _createElement('div', { 'className': 'cm_vehicle-widget_locked__label' }, 'Your Vehicle'), _createElement('div', { 'className': 'cm_vehicle-widget_locked__base' }, this.vehicleBaseValues.join(' ')), _createElement('div', { 'className': 'cm_vehicle-widget_locked__extra' }, '\n              ', window.Convermax.getVehicleExtraValues(this.vehicle).join(' \u2022 '), '\n            '), _createElement('div', { 'className': 'cm_verify-fitment__badge' }, this.fits === 'yes' ? [
        [_createElement('svg', {
                'className': 'cm_icon',
                'width': '12',
                'height': '12',
                'viewBox': '0 0 12 12',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '14680'
            }, _createElement('circle', {
                'cx': '6',
                'cy': '6',
                'r': '5.5',
                'fill': '#104C1B',
                'stroke': 'white'
            }), _createElement('path', {
                'd': 'M4.5 5.75L5.66667 7L8 4.5',
                'stroke': 'white',
                'strokeLinecap': 'round'
            }))],
        _createElement('span', {
            'className': 'cm_verify-fitment__badge-text',
            'key': '14013'
        }, 'Guaranteed Fit')
    ] : null, this.fits === 'no' ? [
        [_createElement('svg', {
                'className': 'cm_icon',
                'width': '12',
                'height': '12',
                'viewBox': '0 0 12 12',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '19440'
            }, _createElement('circle', {
                'cx': '6',
                'cy': '6',
                'r': '5.5',
                'fill': '#B02626',
                'stroke': 'white'
            }), _createElement('path', {
                'd': 'M8 4L4 8',
                'stroke': 'white',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            }), _createElement('path', {
                'd': 'M4 4L8 8',
                'stroke': 'white',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            }))],
        _createElement('span', {
            'className': 'cm_verify-fitment__badge-text',
            'key': '18783'
        }, 'Does Not Fit')
    ] : null)), _createElement('button', {
        'className': 'cm_vehicle-widget_locked__edit',
        'onClick': this.openDialog,
        'role': 'button',
        'tabIndex': '0'
    }, '\n            Edit Vehicle\n          ')), _createElement('div', { 'className': 'cm_verify-fitment_title' }, this.fits === 'yes' ? [scopeVerifyFitmentInfo6.apply(this, [])] : null), this.fits === 'no' ? _createElement('div', {
        'className': 'cm_verify-fitment_compatible-parts-container',
        'key': '4331'
    }, _createElement('a', {
        'href': this.getVehicleUrl(),
        'className': 'cm_verify-fitment_compatible-parts'
    }, '\n            ', _translate(`verify_fitment_compatible_parts`), '\n          ')) : null))) : null, this.template === 'inexact' ? _createElement('div', {
        'className': 'cm_vehicle-widget_specifier cmTemplate_inexact',
        'key': '4641'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n      ', _translate(`verify_fitment_specify`, { 
        fieldsToSpecify: this.
        fieldsToSpecify, 
        vehicleString
    : this.
        vehicleString
     }), '\n    '), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects7.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button button button--primary button',
        'onClick': this.selectVehicle,
        'disabled': !this.allowToSetVehicle,
        'role': 'button',
        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
    }, '\n    ', _translate(`garage_add_button`), '\n  ')))) : null, this.template === 'unknown' ? _createElement('div', {
        'className': 'cm_vehicle-widget_label cm_verify-fitment cm_verify-fitment__unknown cmTemplate_unknown',
        'key': '15901'
    }, _createElement('div', { 'className': 'cm_verify-fitment_icon' }, this.fits === 'yes' || this.fits === 'universal' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-check',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 492 492',
            'key': '160940'
        }, _createElement('path', { 'd': 'm484.13 104.48-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856s-13.964 2.788-19.028 7.856l-226.45 226.45-141.48-141.49c-5.064-5.06-11.82-7.852-19.028-7.852-7.204 0-13.956 2.792-19.024 7.852l-16.12 16.112c-5.068 5.076-7.852 11.836-7.852 19.036 0 7.204 2.784 13.96 7.852 19.028l159.74 159.74c0.212 0.3 0.436 0.58 0.696 0.836l16.12 15.852c5.064 5.048 11.82 7.572 19.084 7.572h0.084c7.212 0 13.968-2.524 19.024-7.572l16.124-15.992c0.26-0.256 0.48-0.468 0.612-0.684l244.78-244.76c10.5-10.476 10.5-27.52 4e-3 -38.008z' }))] : null, this.fits === 'no' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-times',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 22 22',
            'key': '168220'
        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))] : null, this.fits === 'unknown' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-questionmark',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': '0 0 512 512',
            'key': '170120'
        }, _createElement('path', {
            'd': 'M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324',
            'fill': 'none',
            'stroke': '#000',
            'strokeLinecap': 'round',
            'strokeMiterlimit': '10',
            'strokeWidth': '60'
        }), _createElement('circle', {
            'cx': '248',
            'cy': '399.99',
            'r': '32',
            'fill': '#000'
        }))] : null, this.fits === 'aggressive' ? [_createElement('svg', {
            'className': 'cm_icon cm_icon-exclamation',
            'height': '20',
            'viewBox': '0 0 256 255',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '175200'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
        }))] : null), _createElement('div', { 'className': 'cm_verify-fitment_fitment' }, _createElement('div', { 'className': 'cm_verify-fitment_title' }, window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`)), _createElement('div', { 'className': 'cm_verify-fitment_notes' }, window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`)))) : null);
}
        export const componentNames = ["cm:filterInput"]